import { useDispatch } from "react-redux";
import { setQuitConfirmationState } from "../../../features/componentStateSlice.js";

export default function CancelQuitButton() {
    const dispatch = useDispatch();

    const handleCancelButtonClick = () => {
        dispatch(setQuitConfirmationState(false));
    };

    return (
        <button id="cancel-quit-button" onClick={ handleCancelButtonClick }>Cancel</button>
    );
};
